import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { MapLink, MapLinkText } from '../styled';
import Icon from '../../../Icon';
import MapIcon from '../../../../public/static/images/new_search/icons/map-icon.svg';
import ListIcon from '../../../../public/static/images/new_search/icons/show-as-list.svg';

interface ItemsViewToggleLinkProps {
  isMapView: boolean;
  query: string;
}

export const ItemsViewToggleLink: React.FC<ItemsViewToggleLinkProps> = ({
  isMapView,
  query
}) => {
  const { t } = useTranslation();
  const router = useRouter();

  const nextUrl = useMemo(() => {
    const [path, queryString = ''] = router.asPath.split('?');
    const params = new URLSearchParams(queryString);

    params.set(query, isMapView ? 'list' : 'map');

    const qs = params.toString();
    return qs ? `${path}?${qs}` : path;
  }, [router.asPath, isMapView, query]);

  const handleClick = (e: MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    router.push(nextUrl, undefined, {
      shallow: true,
      scroll: false
    });
  };

  return (
    <MapLink
      href={nextUrl}
      onClick={handleClick}
      rel="noopener noreferrer"
      data-cy="new-search-map-link"
      data-stat="new-search-map-link"
      $isMapView={isMapView}
    >
      <Icon
        IconComponent={isMapView ? ListIcon : MapIcon}
        width={20}
        height={20}
        indent={false}
        color="white"
      />
      <MapLinkText tag="body_1">
        {t(isMapView ? 'new_search.list' : 'new_search.map')}
      </MapLinkText>
    </MapLink>
  );
};
